/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_TitleInputs */



/**
* | output |
* | --- |
* | "Finals" |
*
* @param {Finals_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_title = /** @type {((inputs?: Finals_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finali")
	return /** @type {LocalizedString} */ ("Finals")
});